const SideNavigation = {
  el: {
    sidebarItems: document.querySelectorAll('.side-navigation__item'),
  },

  init() {
    if (this.el.sidebarItems) {
      this.el.sidebarItems.forEach((item) => {
        const link = item.querySelector('.side-navigation__link')

        if (link) {
          link.addEventListener('click', (event) => {
            event.preventDefault()

            const href = link.getAttribute('href')

            setTimeout(() => {
              window.location.href = href
            }, 500)

            this.el.sidebarItems.forEach((item) => {
              item.classList.remove('side-navigation__item--active')
            })

            item.classList.add('side-navigation__item--active')
          })
        }
      })
    }
  },
}

export default SideNavigation
